<div
    [ngClass]="{
        loader: true,
        small: size === 'small',
        inverse: inverse,
    }"
>
    @if (style === "spinner") {
        <svg class="inner" viewBox="25 25 50 50">
            <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10" />
        </svg>
    } @else {
        <div class="inner"></div>
    }
</div>
